// Hideo - user-chosen colours (formats, projects): #rrggbb only, otherwise the first one of the palette
export const SERIES_COLORS = ['#e85d4e', '#f59e0b', '#22c55e', '#06b6d4', '#3b82f6', '#8b5cf6', '#ec4899', '#64748b']
/** A #rrggbb colour (the only colour format the data keeps) */
export const isHex = (c: unknown): c is string => typeof c === 'string' && /^#[0-9a-f]{6}$/i.test(c)
export const safeColor = (c: unknown): string => (isHex(c) ? c : SERIES_COLORS[0])

// Contrast between two [r,g,b] colours as in the WCAG guidelines: 1 = same, 21 = black on white (src/features/theme.ts, the editor's
// fixContrast in src/features/editor/colors.ts)
/** Relative luminance of an [r,g,b] colour (0 = black, 1 = white) */
export const relLum = (c: number[]): number => {
  const f = (v: number) => { v /= 255; return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4 }
  return 0.2126 * f(c[0]) + 0.7152 * f(c[1]) + 0.0722 * f(c[2])
}
/** Contrast ratio of two [r,g,b] colours (1 … 21) */
export const contrastOf = (a: number[], b: number[]): number => {
  const x = relLum(a), y = relLum(b)
  return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05)
}
/** "rgb(1, 2, 3)" / "rgba(...)" → [1,2,3]; null if transparent or unreadable */
export const cssRgb = (s: unknown): number[] | null => {
  const m = String(s || '').match(/rgba?\(([^)]+)\)/)
  if (!m) return null
  const p = m[1].split(/[\s,/]+/).filter(Boolean).map(parseFloat)
  return p.length > 3 && p[3] === 0 ? null : p.slice(0, 3)
}

/** A small round dot of a colour (projects, formats); HTML */
export const colorDot = (c: string, cls = 'w-2.5 h-2.5'): string => `<span class="${cls} rounded-full inline-block flex-shrink-0" style="background:${safeColor(c)}"></span>`
